export interface IDonorSearchMicrositeResult {
    id: number,
    firstName: string,
    lastName: string
}